/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfiguratorAttributeCheckBoxComponent } from './configurator-attribute-checkbox.component';
import { ConfiguratorPriceModule } from '../../../price/configurator-price.module';
import { ConfiguratorAttributeCompositionConfig } from '../../composition';
import {KeyboardFocusModule} from "@lm-nx-frontend/lm-inf-ui";
import {I18nModule, provideDefaultConfig} from "@lm-nx-frontend/lm-inf-core";

@NgModule({
  imports: [
    KeyboardFocusModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    I18nModule,
    ConfiguratorPriceModule,
  ],
  providers: [
    provideDefaultConfig(<ConfiguratorAttributeCompositionConfig>{
      productConfigurator: {
        assignment: {
          AttributeType_checkBox: ConfiguratorAttributeCheckBoxComponent,
        },
      },
    }),
  ],
  declarations: [ConfiguratorAttributeCheckBoxComponent],
  exports: [ConfiguratorAttributeCheckBoxComponent],
})
export class ConfiguratorAttributeCheckboxModule {}
